function apiClrDict() {
  let res = [
    { apiKey: 'color_diamonds', feKey: 'diamonds' },
    { apiKey: 'color_spades', feKey: 'spades' },
    { apiKey: 'color_clubs', feKey: 'clubs' },
    { apiKey: 'color_hearts', feKey: 'hearts' },
    { apiKey: 'color_card_back', feKey: 'card_back' },
    {
      apiKey: 'color_eveqeqrbl',
      feKey: 'eveqeqrbl',
      clrSecond: 'eveqeqrbl_2',
      clrThird: 'eveqeqrbl_3',
    },
    { apiKey: 'color_range', feKey: 'range' },

    { apiKey: 'color_range_text', feKey: 'range_text' },
    { apiKey: 'color_combo_text', feKey: 'combo_text' },
    { apiKey: 'color_action_text', feKey: 'action_text' },

    { apiKey: 'color_range_active', feKey: 'range_active' },
    { apiKey: 'color_range_empty', feKey: 'range_empty' },
    { apiKey: 'color_combo_range_active', feKey: 'combo_range_active' },
    { apiKey: 'color_combo_range_empty', feKey: 'combo_range_empty' },

    { apiKey: 'color_ip', feKey: 'player_ip' },
    { apiKey: 'color_oop', feKey: 'player_oop' },

    { apiKey: 'color_call', feKey: 'C' },
    { apiKey: 'color_check', feKey: 'X' },
    { apiKey: 'color_fold', feKey: 'F' },
    { apiKey: 'color_raise_default', feKey: 'R_default' },
    { apiKey: 'color_raise1', feKey: 'R1', clrSecond: 'R1_2' },
    { apiKey: 'color_raise2', feKey: 'R2', clrSecond: 'R2_2' },
    { apiKey: 'color_raise3', feKey: 'R3', clrSecond: 'R3_2' },
    { apiKey: 'color_raise4', feKey: 'R4', clrSecond: 'R4_2' },

    { apiKey: 'color_trainer_active_canvas_back', feKey: 'trainer_active_canvas_back' },
    { apiKey: 'color_trainer_active_canvas_outline', feKey: 'trainer_active_canvas_outline' },
    { apiKey: 'color_trainer_active_table_back', feKey: 'trainer_active_table_back' },
    { apiKey: 'color_trainer_active_table_outline', feKey: 'trainer_active_table_outline' },

    { apiKey: 'color_trainer_canvas_back', feKey: 'trainer_canvas_back' },
    { apiKey: 'color_trainer_canvas_outline', feKey: 'trainer_canvas_outline' },
    { apiKey: 'color_trainer_table_back', feKey: 'trainer_table_back' },
    { apiKey: 'color_trainer_table_outline', feKey: 'trainer_table_outline' },

    { apiKey: 'color_trainer_player_active', feKey: 'trainer_player_active' },
    { apiKey: 'color_trainer_player_folded', feKey: 'trainer_player_folded' },
    { apiKey: 'color_trainer_player_hero', feKey: 'trainer_player_hero' },
    { apiKey: 'color_trainer_player_opponent', feKey: 'trainer_player_opponent' },

    { apiKey: 'color_trainer_pattern', feKey: 'trainer_pattern' },
    { apiKey: 'color_trainer_hand_highlight', feKey: 'trainer_hand_highlight' },
    {
      apiKey: 'color_trainer_action_btn_default_background',
      feKey: 'trainer_action_btn_default_background',
    },
  ]
  res = res.map(i => ({ ...i, category: 'colors' }))
  return res
}

function apiStylesDict() {
  let res = [
    { apiKey: 'style_card', feKey: 'cardTheme' },
    { apiKey: 'style_card_back', feKey: 'cardBack' },
    { apiKey: 'style_comparison_chart', feKey: 'styleEqBuckets' },
    { apiKey: 'style_trainer_back_pattern', feKey: 'traineBackPattern' },
    { apiKey: 'style_action_btn_text_shadow', feKey: 'actionBtnShadowStyle' },
    { apiKey: 'style_range_cell_text_shadow', feKey: 'rangeCellShadowStyle' },
  ]
  res = res.map(i => ({ ...i, category: 'styles' }))
  return res
}
function apiMiscDict() {
  let res = [
    { apiKey: 'show_bets_in', feKey: 'showBetsIn' },
    { apiKey: 'show_ev_in', feKey: 'showEvIn' },
    { apiKey: 'show_ev_icm_in', feKey: 'showEvIcmIn' },
    { apiKey: 'show_numbers_in_table', feKey: 'showHandValue' },
    { apiKey: 'show_loading_tips', feKey: 'showLoadingTips' },
    { apiKey: 'show_solutions_dialog', feKey: 'showSolutionsDialog' },
    { apiKey: 'switchers_defaults', feKey: 'switchersDefaults' },
    { apiKey: 'show_legacy_solutions', feKey: 'showLegacySolutions' },
    { apiKey: 'keep_filters_between_spots', feKey: 'keepFiltersBetweenSpots' },
    { apiKey: 'gmf_stacks_table_as_grid', feKey: 'gmfStacksTableAsGrid' },
    { apiKey: 'gmf_keep_history', feKey: 'gmfKeepHistory' },
    { apiKey: 'sound_volume', feKey: 'soundVolume' },
    { apiKey: 'solfigr_dashboard', feKey: 'solfigrDashboard' },
  ]
  res = res.map(i => ({ ...i, category: 'misc' }))
  return res
}

function apiDict() {
  return [
    ...apiClrDict(), //
    ...apiMiscDict(),
    ...apiStylesDict(),
  ]
}

export { apiClrDict, apiMiscDict, apiStylesDict, apiDict }
//
